import { mapActions, mapState } from 'vuex'
import { ErrorHelper } from '@/helpers/ErrorHelper'
import { SelectedSiteIdMixin } from './SelectedSiteIdMixin'

export const FormatOptionsDateCacheMixin = {
  mixins: [SelectedSiteIdMixin],
  computed: {
    ...mapState('FormatOptionsDate', [
      'fetchingDateFormatOptions',
      'fetchedDateFormatOptions',
      'dateFormatOptions'
    ])
  },
  watch: {
    selectedSiteId () {
      this.refreshDateFormatOptions()
    }
  },
  methods: {
    ...mapActions('FormatOptionsDate', [
      'fetchDateFormatOptionsBySiteId'
    ]),
    refreshDateFormatOptions () {
      if (!this.fetchedDateFormatOptions && !this.fetchingDateFormatOptions) {
        this.tryFetchDateFormatOptionsBySiteId()
      }
    },
    tryFetchDateFormatOptionsBySiteId () {
      const self = this
      if (!self.selectedSiteId) {
        return
      }
      self.error = ''
      self.fetchDateFormatOptionsBySiteId(self.selectedSiteId)
        .catch(error => { self.error = ErrorHelper.getError(error) })
    }
  },
  created () {
    this.refreshDateFormatOptions()
  }
}
